import {
  Fragment,
} from 'react';
import {
  usePageContext,
} from 'vike-react/usePageContext';
import {
  useUsers,
  useAuthentication,
} from '@dinosave/core/stores';
import UserImage from '@/components/Users/UserImage';
import {
  USER,
} from '@/constants/namespaces';
import Button from '@/ui/components/Button';
import Text from '@/ui/components/Text';
import {
  ChevronLeftIcon,
} from '@/ui/icons';

import styles from './BackButton.module.css';

const BackButton = () => {
  // ##########################################################################
  // PARAMS
  // ##########################################################################

  const {
    routeParams,
  } = usePageContext();

  const {
    userSlug: paramsUserSlug,
    wishlistSlug: paramsWishlistSlug,
  } = routeParams;

  // ##########################################################################
  // STORES
  // ##########################################################################

  const authenticatedUser = useAuthentication(s => s.authenticatedUser);
  const authenticatedUserSlug = authenticatedUser?.slug;
  const authenticatedUserName = authenticatedUser?.name;

  const user = useUsers(USER, s => s.user);
  const userSlug = user?.slug || authenticatedUserSlug;

  // ##########################################################################
  // CONSTANTS
  // ##########################################################################

  let backTo = '/';

  if (
    authenticatedUserSlug &&
    paramsWishlistSlug
  ) {
    backTo = `/u/${userSlug}`;
  } else if (
    authenticatedUserSlug &&
    paramsUserSlug !== authenticatedUserSlug
  ) {
    backTo = `/u/${authenticatedUserSlug}`;
  }

  const isBackAvailable = backTo !== '/';

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={styles.back}>
      <a href={backTo}>
        <div className={styles.backButton}>
          <Button
            kind="link"
            color="secondary"
            roundness="rounded"
          >
            {!isBackAvailable && (
              <div className={styles.logoImage}>
                <img
                  alt="logo"
                  src="/images/logo/with-text.png"
                />
              </div>
            )}

            {isBackAvailable && (
              <Fragment>
                <ChevronLeftIcon />

                {paramsWishlistSlug ? (
                  <div className={styles.everything}>
                    <Text
                      kind="caption"
                      size="small"
                      color="neutral-500"
                    >
                      Back to
                    </Text>

                    <Text
                      kind="control"
                      size="large"
                    >
                      Everything
                    </Text>
                  </div>
                ) : (
                  <div className={styles.user}>
                    <div className={styles.userImage}>
                      <UserImage
                        user={authenticatedUser}
                        roundness="round"
                      />
                    </div>

                    <Text
                      kind="control"
                      size="large"
                    >
                      {authenticatedUserName}
                    </Text>
                  </div>
                )}
              </Fragment>

            )}
          </Button>
        </div>
      </a>
    </div>
  );
};

export default BackButton;
